import React from "react";
import { SpinningLoader } from "risa-oasis-ui_v2";
import { CommonLiterals } from "../../../../enums/StringLiterals/commonLiterals";
import { InfoIcon } from "../../../../svg/info-icon";
import PdfRender from "../../../pdfRender/pdfRender";
import { useFinalScreenshotFromSlice } from "../hooks/useFinalScreenshotFromSlice";

interface ScreenshotRendererTabProps {
  orderId?: string;
  cmmStatus?: string;
}

const ScreenshotRendererTab: React.FC<ScreenshotRendererTabProps> = ({
  orderId,
  cmmStatus,
}) => {
  const { finalDocUrl, formattedTime, loading } = useFinalScreenshotFromSlice(
    orderId,
    cmmStatus,
  );

  return (
    <div className="flex h-full w-full border-1 border-primaryGray-15 bg-[#F7F9FA]">
      <div className="flex h-full flex-1 flex-col overflow-hidden rounded-md border border-primaryGray-15 bg-white">
        <div className="flex flex-row justify-between border-b border-primaryGray-15 bg-primaryGray-16 px-4 py-2 text-small font-semibold leading-6 text-primaryGray-1 shadow-md">
          Final Screenshots
          <div>
            {formattedTime}
            <span className="ml-1">{`(IST)`}</span>
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-2 overflow-auto px-4 py-2">
          {loading ? (
            <div className="flex h-full w-full flex-col items-center justify-center gap-2">
              <SpinningLoader />
              <div className="text-sm text-primaryGray-6">
                {CommonLiterals.LOADING_FINAL_SCREENSHOT}
              </div>
            </div>
          ) : (
            finalDocUrl && <PdfRender file={finalDocUrl} />
          )}
        </div>
        {!loading && !finalDocUrl && (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2">
            <InfoIcon width="48" height="48" stroke="#6B7280" strokeWidth="1" />
            <div className="text-sm text-primaryGray-6">
              {CommonLiterals.NO_SCREENSHOT_AVAILABLE}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScreenshotRendererTab;
